import { ListboxButton, useListboxContext } from '@reach/listbox';
import { useState, useEffect } from 'react';
import { createComponent } from '../../../react/components/core/create-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const getAriaAttributes = (ctx)=>{
    var _ctx_highlightedOptionRef, _ctx_highlightedOptionRef_current, _ctx_selectedOptionRef, _ctx_selectedOptionRef_current;
    return {
        'aria-activedescendant': !ctx.isExpanded ? ((_ctx_highlightedOptionRef = ctx.highlightedOptionRef) === null || _ctx_highlightedOptionRef === void 0 ? void 0 : (_ctx_highlightedOptionRef_current = _ctx_highlightedOptionRef.current) === null || _ctx_highlightedOptionRef_current === void 0 ? void 0 : _ctx_highlightedOptionRef_current.getAttribute('id')) || ((_ctx_selectedOptionRef = ctx.selectedOptionRef) === null || _ctx_selectedOptionRef === void 0 ? void 0 : (_ctx_selectedOptionRef_current = _ctx_selectedOptionRef.current) === null || _ctx_selectedOptionRef_current === void 0 ? void 0 : _ctx_selectedOptionRef_current.getAttribute('id')) || `option-${ctx.value}--${ctx.id}` : undefined,
        'aria-controls': `listbox--${ctx.id}`,
        'aria-owns': `listbox--${ctx.id}`,
        'aria-expanded': `${!!ctx.isExpanded}`
    };
};
/**
 * @deprecated Use new Listbox and its sub-components instead
 */ const LegacyListboxButton = createComponent({
    displayName: 'LegacyListboxButton',
    root: ListboxButton,
    propConfig: {
        classNames: [
            'swan-legacy-listbox-button'
        ],
        derivedProps () {
            const ctx = useListboxContext();
            const [ariaDetails, setAriaDetails] = useState(getAriaAttributes(ctx));
            useEffect(()=>{
                setAriaDetails(getAriaAttributes(ctx));
            }, [
                ctx
            ]);
            return ariaDetails;
        },
        processProps (props, derivedProps) {
            return _object_spread_props(_object_spread({}, props, derivedProps), {
                role: 'combobox',
                'aria-haspopup': undefined,
                arrow: false
            });
        }
    }
});

export { LegacyListboxButton };
